export default {
  renewal_date_override:"Data di rinnovo personalizzata",
  membership_term_start:"Inizio del periodo di iscrizione",
  joined_at:"Data di iscrizione",
  billingFrequency:"Frequenza di fatturazione",
  contractMonths:"Durata del contratto (mesi, 1–120)",
  billingOptions:"Opzioni di fatturazione",
  accountHelp:"Consenti di addebitare gli acquisti idonei sul conto responsabile configurato.",
  duesHelp:"Includi le quote associative nella fatturazione ricorrente. L’iscrizione rimane associata a questo socio.",
  initiationHelp:"Includi la quota di ammissione una sola volta nel ciclo di fatturazione pertinente.",

  accountCharging:"Addebito sul conto consentito",
  duesEnrolment:"Attiva la fatturazione ricorrente e aggiungi le quote associative",
  initiationFee:"Includi la quota di ammissione nel ciclo di fatturazione ricorrente",
  feesHelp:"Le quote associative e di ammissione vengono addebitate sul conto responsabile. Disabilitare l’addebito degli acquisti facoltativi non annulla la fatturazione delle quote.",
  status_open:"Aperto",
  status_paid:"Pagato",
  status_partially_settled:"Parzialmente saldato",
  status_partially_paid:"Parzialmente pagato",
  status_pending:"In attesa",
  status_overdue:"Scaduto",
  status_void:"Annullato",
  status_refunded:"Rimborsato",
  status_reversed:"Stornato",
  status_cancelled:"Annullato",
  status_posted:"Contabilizzato",
  status_invoiced:"Fatturato",
  status_settled:"Saldato",
  status_written_off:"Stralciato",
  status_unknown:"Stato non disponibile",

  billing_option_invalid:"Le opzioni di fatturazione devono essere abilitate o disabilitate.",
  billing_payer_invalid:"Seleziona un socio valido come intestatario pagante del conto.",
  "category": "Categoria socio",
  "adult": "Adulto",
  "child": "Minore",
  "unclassified": "Non classificato (preesistente)",
  "requirePayer": "Richiedi un altro socio come intestatario pagante del conto",
  "thisMember": "Questo socio",
  "anotherMember": "Un altro socio",
  "accountPayer": "Intestatario pagante del conto",
  "search": "Cerca per nome o numero socio",
  "summary": "Gli addebiti idonei di {member} verranno fatturati sul conto di {payer}.",
  "billedTo": "Fatturato a {payer}",
  "forMember": "Per {member}",
  "chargeAccount": "Addebita sul conto di {payer} · Per {member}",
  "linkedCharges": "Addebiti fatturati a un altro socio",
  "searching": "Ricerca soci…",
  "typeToSearch": "Digita almeno 2 caratteri per cercare.",
  "noResults": "Nessun socio trovato.",
  "billing_forbidden": "È necessaria un’autorizzazione per modificare il responsabile della fatturazione.",
  "billing_member_not_found": "Il socio o il pagante non appartiene a questo club.",
  "billing_member_inactive": "Il socio beneficiario del servizio è inattivo.",
  "billing_account_charging_disabled": "L’addebito sul conto è disabilitato per questo socio. Scegli contanti/carta o chiedi al personale di abilitarlo.",
  "billing_another_payer_required": "Questo tipo di iscrizione richiede un altro intestatario pagante. Seleziona un socio idoneo.",
  "billing_payer_required": "Seleziona un intestatario pagante idoneo prima di abilitare la fatturazione sul conto.",
  "billing_override_forbidden": "Non puoi sostituire il pagante configurato.",
  "billing_payer_inactive": "Il pagante è inattivo. Seleziona un altro pagante idoneo.",
  "billing_payer_chain": "Il pagante deve usare il proprio conto e non può trasferire gli addebiti a un altro socio.",
  "billing_payer_ineligible": "Il pagante deve avere un conto idoneo con l’addebito sul conto abilitato.",
  "billing_account_ineligible": "Il conto responsabile è mancante o inattivo. Chiedi al personale di configurare un conto idoneo.",
  "billing_credit_limit": "L’addebito supera il limite di credito del conto responsabile. Scegli contanti/carta o contatta il personale.",
  "billing_mode_invalid": "Scegli Questo socio o Un altro socio.",
  "billing_payer_self": "Scegli Questo socio per usare il tuo conto.",
  "billing_policy_changed": "Le impostazioni di fatturazione sono cambiate. Ricarica il socio prima di salvare.",
  "billing_category_required": "Seleziona Adulto o Minore per un nuovo tipo di iscrizione.",
  "billing_category_invalid": "Seleziona una categoria socio valida.",
  "billing_requirement_invalid": "Seleziona un requisito valido per il pagante."
};
